﻿class loaderIconButtonOptions
{
    button: HTMLButtonElement;
    isInline?: boolean = false;
    useBefore?: boolean = false;
    customFieldValidationSuccess?: boolean = false;
}

export class loaderIconButton
{
    button: HTMLButtonElement;
    isInline: boolean;
    useBefore: boolean;
    customFieldValidationSuccess: boolean;

    constructor(options: loaderIconButtonOptions)
    {
        if (options.button)
            this.button = options.button;

        if (options.isInline)
            this.isInline = options.isInline;

        if (options.useBefore)
            this.useBefore = options.useBefore;

        if (options.customFieldValidationSuccess)
            this.customFieldValidationSuccess = options.customFieldValidationSuccess;

        this.assignEvents();
    }

    private assignEvents()
    {
        this.button.addEventListener("click", (e) =>
        {
            this.show();
        });
    }

    public show(): boolean
    {
        if ($(this.button).hasClass("disabled"))
            return false;

        if (this.customFieldValidationSuccess)
            return false;

        var allowDisabled = false;

        this.toggleLoaderIcon(true);

        if ($(this.button).attr("type") == "submit")
        {
            var form = $(this.button).closest("form");

            if (form && form.length > 0)
            {
                // Add event to check for 'invalid' fields
                $(form).find('input').one('invalid', function (e)
                {
                    allowDisabled = true;
                });
            }
        }

        const loaderIcon = this;

        setTimeout(function (event)
        {
            if (!allowDisabled)
            {
                // button.disabled is undefined when function is passed jquery object
                if (typeof (undefined) != typeof (loaderIcon.button.disabled))
                    loaderIcon.button.disabled = true;
                else
                    loaderIcon.button.setAttribute('disabled', 'disabled');
            }
            else
                loaderIcon.toggleLoaderIcon(false);

        }, 10);

        window.addEventListener("pageshow", function (event) 
	{
            const [entry] = window.performance.getEntriesByType("navigation");

            if (entry.entryType === "back_forward" || event.persisted) 
	    {
                // Reset button after moving through page history
                loaderIcon.button.disabled = false;
                $(loaderIcon.button).removeClass('is-loading');
                loaderIcon.toggleLoaderIcon(false);
            }
        });

        return true;
    }

    public hideLoaderIcon()
    {
        $(this.button).removeClass('is-loading');
    }

    public resetButton()
    {
        $(this.button).removeAttr('disabled');
        this.toggleLoaderIcon(false);

        setTimeout(function ()
        {
            $(this.button).removeAttr('disabled');
        }, 100);
    }

    private toggleLoaderIcon(showLoadIcon)
    {
        // Don't allow when already disabled
        if ($(this.button).attr("disabled"))
            return;

        if (showLoadIcon)
            this.button.classList.add("is-loading");
        else
            this.button.classList.remove("is-loading");
    }
}

export const resetLoaderButton = (selector: HTMLElement | string) =>
{
    let element: HTMLButtonElement;
    if (typeof selector === "string")
        element = document.querySelector(selector);
    else if (selector instanceof HTMLButtonElement)
        element = selector as HTMLButtonElement;
    else
    {
        $(selector).removeAttr("disabled");
        $(selector).removeClass("is-loading");
        return;
    }

    if (element)
    {
        element.disabled = false;
        element.classList.remove("is-loading");
    }
}

document.addEventListener("DOMContentLoaded", () =>
{
    document.querySelectorAll(".btn-loader")?.forEach((item: HTMLButtonElement) =>
    {
        new loaderIconButton({ button: item as HTMLButtonElement });
    });
});